import React, { useState, useEffect } from "react";

const slides = [
  {
    title: "Learn. Build. Excel with Circuitcy",
    subtitle:
      "Practical training and projects in Electrical, Electronics, Telecommunication (ETC), and Information Technology Engineering.",
    bg: "/assets/h1.jpg",
  },
  {
    title: "Hands-on Industry Training",
    subtitle:
      "Work on real-world projects and master the tools engineers use every day.",
    bg: "/assets/h2.png",
  },
  {
    title: "100% Job Placement",
    subtitle:
      "From mock interviews to resume building, we support your journey to the industry.",
    bg: "/assets/h3.png",
  },
];

const HeroCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto change every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full max-w-7xl mx-auto mt-20 h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-xl">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <div
            className="w-full h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.bg})` }}
          >
            <div className="bg-black bg-opacity-60 w-full h-full flex flex-col items-center justify-center px-4 text-center text-white">
              <h1 className="text-3xl md:text-5xl font-bold mb-4 drop-shadow-md">
                {slide.title}
              </h1>
              <p className="text-base md:text-lg mb-6 max-w-2xl drop-shadow">
                {slide.subtitle}
              </p>
              <a
                href="#services"
                className="bg-white text-sky-700 font-semibold px-6 py-2 rounded-full shadow hover:bg-gray-100 transition"
              >
                Explore Now
              </a>
            </div>
          </div>
        </div>
      ))}

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? "bg-white scale-110" : "bg-gray-400"
            } transition-transform duration-300`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
